import RatingStoreDetail from './RatingStoreDetail';
export default RatingStoreDetail;
